<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('view') }} {{ $tc('recipe', 2) }}</div>
      <div>
        <router-link class="btn-blue" :to="'edit-recipe?recipe_id='+recipe_id">{{ $t('edit') }}</router-link>
        <router-link class="btn-blue" to="recipes">{{ $tc('recipe', 2) }} {{ $tc('list', 2) }}</router-link>
        <router-link class="btn-blue" to="fnb-items">{{ $t('fnbitems') }} {{ $tc('list', 2) }}</router-link>
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('recipe', 1) }} {{ $t('name') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{ recipeDetails.recipe_name }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('recipe', 1) }} {{ $t('code') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{ recipeDetails.recipe_code }}</div>
            </div>
          </div>

          <table class="table table-striped">
            <thead>
              <tr>
                <th>{{ $t('ingredient') }}</th>
                <th>{{ $t('quantity') }}</th>
                <th>{{ $tc('unitofmeasurement', 1) }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(recipe,recipeKey) in recipeItems" :key="recipeKey">
                <td>{{recipe.rm_name}}</td>
                <td>{{ recipe.ri_quantity }}</td>
                <td>{{recipe.uom_unit}}</td>
              </tr>
              <!-- <tr>
                <td>Mary</td>
                <td>Moe</td>
                <td>mary@example.com</td>
              </tr>-->
              <!-- <tr>
                <td>July</td>
                <td>Dooley</td>
                <td>july@example.com</td>
              </tr>-->
            </tbody>
          </table>

          <!-- <div class="row" v-for="(recipe,recipeKey) in recipeItems" :key="recipeKey">
            <div class="col-md-12 py-2 border-bottom">
              <div class="row">
                <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('ingredient') }}</div>
                <div class="col-md-9 col-lg-10 col-xl-10">{{ recipe.rm_name }}</div>
              </div>
            </div>

            <div class="col-md-12 py-2 border-bottom">
              <div class="row">
                <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('quantity') }}</div>
                <div class="col-md-9 col-lg-10 col-xl-10">{{ recipe.ri_quantity }}</div>
              </div>
            </div>

            <div class="col-md-12 py-2 border-bottom">
              <div class="row">
                <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('unitofmeasurement', 2) }}</div>
                <div class="col-md-9 col-lg-10 col-xl-10">{{ recipe.uom_unit }}</div>
              </div>
            </div>
          </div>-->

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('status', 1) }}</div>
              <div
                v-if="recipeDetails.recipe_is_active == 'Y'"
                class="col-md-9 col-lg-10 col-xl-10"
              >{{ $t('active') }}</div>
              <div v-else class="col-md-9 col-lg-10 col-xl-10">{{ $t('inactive') }}</div>
            </div>
          </div>

          <div class="col-12" v-if="GetRoleId && GetRoleId === 1 ">
            <div class="row">
              <div class="col-md-12 py-2 border-bottom">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdby') }}</div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span>{{ recipeDetails.created_by }}</span>
                  </div>
                </div>
              </div>

              <div class="col-md-12 py-2 border-bottom">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdat') }}</div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span class="mr-3">{{ recipeDetails.created_at | dateparse }}</span>
                    <!-- <span>12:05 AM</span> -->
                  </div>
                </div>
              </div>

              <div class="col-md-12 py-2 border-bottom">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('modifiedby') }}</div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span>{{ recipeDetails.updated_by }}</span>
                  </div>
                </div>
              </div>

              <div class="col-md-12 py-2">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('modifiedat') }}</div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span class="mr-3">{{ recipeDetails.updated_at | dateparse }}</span>
                    <!-- <span>12:05 AM</span> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
 <script>
import PosFnbService from "@/services/PosFnbService.js";
import MasterService from "@/services/MasterService.js";
export default {
  data() {
    return {
      recipeDetails: {},
      recipeItems: [],
      recipe_id: ""
    };
  },
  beforeMount() {
    this.recipe_id = this.$route.query.recipe_id;
  },
  mounted() {
    this.getRecipeDetails();
  },
  methods: {
    getRecipeDetails: function() {
      let payload = {
        recipe_id: this.recipe_id
      };
      PosFnbService.GetRecipe(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.recipeDetails = data.Records[0];
            Object.keys(this.recipeDetails).map(x => {
              if (x == "created_by") {
                console.log("x", this.recipeDetails[x]);
                this.getViewUsersDetails(this.recipeDetails[x], "created_by");
              } else if (x == "updated_by") {
                console.log("x", this.recipeDetails[x]);

                this.getViewUsersDetails(this.recipeDetails[x], "updated_by");
              }
            });
            data.Records.map(x => {
              this.recipeItems.push(x);
            });
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    getViewUsersDetails(user_id, key) {
      if (user_id) {
        MasterService.GetUserInfoById({ user_id })
          .then(response => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.recipeDetails[key] = data.Records[0].user_name;
            } else {
              // Error Message
              console.log("data.message :", data.message);
            }
          })
          .catch(error => {
            // Catch Error
            console.log("Catch Error on getViewUsersDetails :", error);
          });
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/RecipesComponents/viewRecipe.vue